import { render } from "./visitforms.vue?vue&type=template&id=157fa516"
import script from "./visitforms.vue?vue&type=script&lang=js"
export * from "./visitforms.vue?vue&type=script&lang=js"

import "./visitforms.vue?vue&type=style&index=0&id=157fa516&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__